/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EdicionFormAdminController', EdicionFormAdminController);

    /* @ngInject */
    function EdicionFormAdminController($timeout, $state, itemData, Principal, AlertService, Responsable, Lugar, Catalogo, Epiteto, Idioma,
                                        roles, tamanos, portadas, tipoletras, modalidaddiscursos, relacion, previousParams) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.item = itemData;
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        if (!vm.item.titulo) {
            vm.item.titulo = relacion.titulo;
        }

        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole = Principal.identity().$$state.value.role;

        if (vm.mode === 'edit') {
            Principal.hasAuthority("ROLE_ADMIN").then(function (esAdmin) {
                if (!esAdmin && vm.item.nombreUsuario != vm.userName) {
                    AlertService.warning("admin.edicion.error.unauthorized", null, 0);
                }
            });
        }


        /**
         * Guardar formulario
         * Hay que comprobar los campos que representan a otras entidades del modelo (o enumerados) que tienen relacion
         * ManyToOne con esta entidad, porque si tenían un valor, se elimina y se guarda, hay que ponerlo a null desde aquí
         */
        vm.save = function () {

            //para cada ilustración es necesario borrar la última imagen adjunta (es nula)
            //Si dicha imagen se elimina, se produce un efecto visual no deseado al darle a "guardar"
            //Por eso, creo una copia de la edición, que será a la que le hago las modificaciones, y que le envío al servidor
            vm.copiaItem = angular.copy(vm.item);

            vm.copiaItem.ilustraciones.forEach(function (copiaItem) {

                if (copiaItem.imagenes.length == 1) {
                    copiaItem.imagenes = [];
                } else {
                    if (copiaItem.imagenes[(copiaItem.imagenes.length - 1)].nombre == null) {
                        copiaItem.imagenes.splice((copiaItem.imagenes.length - 1));
                    }
                }
            });
            if (vm.mode === 'edit') {
                vm.copiaItem.$save().then(function (data) {
                    $state.go('admin/edicion/list', previousParams);
                });
            }
            if (vm.mode === 'create') {
                vm.copiaItem.$save().then(function (data) {
                    $state.go('admin/ejemplar/list', {edicionId: data.id});
                });
            }
        };

        vm.responsableService = Responsable;
        vm.lugarService = Lugar;
        vm.roles = roles;
        vm.catalogoService = Catalogo;
        vm.epitetoService = Epiteto;
        vm.idiomaService = Idioma;
        vm.tamanos = tamanos;
        vm.portadas = portadas;
        vm.tipoletras = tipoletras;
        vm.modalidaddiscursos = modalidaddiscursos;

    }

})(angular);
